// packages/shared/src/rules/permissions.ts
import type { ObjectKind } from '@whiskerton/content';
import type { ResidentId } from '../types/ids';
import type { Plot } from '../types/map';
import type { ResidentRole } from '../types/resident';
import type { TownSettings } from '../types/town';
import { inRect } from '../geom';
export const MAYOR_REMOVABLE: readonly ObjectKind[] = ['tree', 'rock', 'decor', 'stump'];
export function canRemovePlaced(actor: { id: ResidentId; isMayor: boolean }, item: { owner: ResidentId | null }): boolean {
  return actor.isMayor || (item.owner !== null && item.owner === actor.id);
}
export function canInvite(role: ResidentRole, settings: TownSettings): boolean {
  return role === 'mayor' || settings.residentsCanInvite;
}
/** Mayor only; kind in MAYOR_REMOVABLE; anchor tile outside every plot rect (spec §4.4 "public spaces"). */
export function canRemoveObject(actor: { isMayor: boolean }, obj: { kind: ObjectKind; x: number; y: number }, plots: readonly Plot[]): boolean {
  return actor.isMayor && MAYOR_REMOVABLE.includes(obj.kind) && !plots.some((p) => inRect(p.rect, obj.x, obj.y));
}
